export const SCROLL_ANIMATION_TRIGGER_VALUE = 10;

export const SCROLL_ANIMATION_DURATION = 500;
